import './slider-text-teaser.scss';
import Swiper from 'swiper/bundle';

class Slider {
    constructor (element) {
        this.$slider = element;
        this.$sliderImage = this.$slider.querySelectorAll('[data-slider="image"]')[0];
    }

    init () {
        this.$sliderImage.addEventListener('lazyloaded', () => {
            this.initSlider();
        });
    }

    initSlider () {
        this.$slider = new Swiper(this.$slider, {
            slidesPerView: 1,
            autoHeight: true,
            speed: 500,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets'
            },
            navigation: {
                nextEl: '.image-slider__next',
                prevEl: '.image-slider__prev'
            }
        });

        this.$slider.on('slideChangeTransitionStart', () => {
            this.borderRadiusTransition();
        });

        this.$slider.on('sliderMove', () => {
            this.borderRadiusTransition();
        });
    }

    borderRadiusTransition () {
        const $sliderTeaserFirst = document.querySelector('.slider-text-teaser__first');
        const $sliderImages = document.querySelectorAll('.image-slider__image');
        $sliderTeaserFirst.classList.add('has--no-border-radius');
        setTimeout(() => {
            $sliderTeaserFirst.classList.remove('has--no-border-radius');
        }, 500);
        for (let i = 0; i < $sliderImages.length; i++) {
            $sliderImages[i].classList.add('has--no-border-radius');
            setTimeout(() => {
                $sliderImages[i].classList.remove('has--no-border-radius');
            }, 1000);
        }
    }
}

export { Slider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $imageSlider = $context.querySelectorAll('[data-slider="root"]');
        for (let i = 0; i < $imageSlider.length; i++) {
            const $slider = new Slider($imageSlider[i]);
            $slider.init($imageSlider[i]);
        }
    }
});
